module.exports = __webpack_public_path__ + "img/SIPSD.b90989e5.svg";